module.exports = __webpack_public_path__ + "static/img/login_part01_img02.08148e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_part01_img02.png
// module id = eDhC
// module chunks = 1